// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/solid/arrow-up.svg. Do not edit.

import { glyph } from '@gto/icons/glyphs/solid/arrow-up'

import { Icon, type IconComponentProps } from '../icon'

export const ArrowUpIcon = (props: IconComponentProps) => (
  <Icon
    glyph={glyph}
    {...props}
  />
)
